import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import env from 'src/env'
import { AvailableLanguage, LanguageCode } from './types'

const { English, Dutch, French, German } = LanguageCode

export const DEFAULT_LANGUAGE = English

export const LANGUAGE_NAMES = Object.freeze({
  [English]: 'English',
  [Dutch]: 'Nederlands',
  [French]: 'Français',
  [German]: 'Deutsch',
})

/** Probably not very useful, as frontend translations are not up to date. */
export const DEFAULT_LANGUAGE_OPTIONS: AvailableLanguage[] = [
  { code: English, name: LANGUAGE_NAMES[English] },
  { code: Dutch, name: LANGUAGE_NAMES[Dutch] },
]

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    lng: DEFAULT_LANGUAGE,
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'common',
    backend: {
      loadPath: `${env.API_URL}/api/locales/{{lng}}/{{ns}}`,
    },
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator'],
      caches: ['localStorage'],
      htmlTag: document.documentElement,
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  })

void i18n.changeLanguage(DEFAULT_LANGUAGE)

window.i18next = i18n

export default i18n
